import React from 'react';
import { Menu } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import LocaleSwitcher from './LocaleSwitcher';

function ShareHeader() {
  const logoUrl = useSelector((state) => state.auth.user.logoUrl);
  return (
    <div className="ui top menu">
      {logoUrl && (
        <Menu.Item>
          <img className="ui left attached logo image" src={`${logoUrl}`} alt="Client Logo" />
        </Menu.Item>
      )}
      <Menu.Item position="right" style={{ marginRight: '10px' }}>
        <LocaleSwitcher />
      </Menu.Item>
    </div>
  );
}

export default ShareHeader;
